import api from "src/apis/api"

export async function fetchTemplates({ channel = "", category = "", q = "" } = {}) {
  const params = new URLSearchParams()
  if (channel) params.set("channel", channel)
  if (category) params.set("category", category)
  if (q) params.set("q", q)
  const { data } = await api.get(`/api/v1/templates?${params}`)
  return data
}

export async function createTemplate(payload) {
  const { data } = await api.post("/api/v1/templates", { template: payload })
  return data
}

export async function updateTemplate(id, payload) {
  const { data } = await api.patch(`/api/v1/templates/${id}`, { template: payload })
  return data
}

export async function deleteTemplate(id) {
  const { data } = await api.delete(`/api/v1/templates/${id}`)
  return data
}

// Grouped variable catalog for the editor picker, scoped to a category.
export async function fetchVariables(category) {
  const params = new URLSearchParams()
  if (category) params.set("category", category)
  const { data } = await api.get(`/api/v1/templates/variables?${params}`)
  return data.variables
}

// Live preview render. Without a recipient it renders sample data (template
// editor); with one it renders the real record (leads messaging drawer).
export async function previewTemplate(id, recipient = null) {
  const payload = recipient ? { recipient_type: recipient.type, recipient_id: recipient.id } : {}
  const { data } = await api.post(`/api/v1/templates/${id}/preview`, payload)
  return data
}

// Render a template against a real recipient and queue the message.
// recipient = { type: "Lead" | "Contact" | "PropertyListing", id }
// body (optional) overrides the server-rendered text with the user's edits.
// provider (optional) pins which enabled provider dispatches the message when
// the org has more than one for the channel.
export async function sendTemplateMessage(templateId, { recipient, to_address, body, provider }) {
  const { data } = await api.post(`/api/v1/templates/${templateId}/send_message`, {
    recipient_type: recipient.type,
    recipient_id: recipient.id,
    to_address,
    body,
    provider,
  })
  return data
}
